export default __webpack_public_path__ + "static/media/unchecked.b96eb611.svg";